module.exports = __webpack_public_path__ + "img/router.981ae0ed.svg";